import { gql } from "@apollo/client";

export const BRANDS = gql`
  query vehicleBrands {
    vehicleBrands {
      id
      name
      is_actived
    }
  }
`;

export default BRANDS;
